export default "__VITE_ASSET__DY7JqbGS__"